<div class="ag-cell-editor fx-layout-row fx-justify-space-between fx-align-center">
  <input [formControl]="control" matInput class="ag-input-field-input" type="text" autocomplete="off"
    (focus)="datePicker.open()" (dateChange)="dateChange()" [id]="'date'" [matDatepicker]="datePicker" />
  <mat-datepicker-toggle [for]="datePicker" matIconSuffix></mat-datepicker-toggle>
  <mat-datepicker #datePicker color="accent" disabled="false"></mat-datepicker>

  @if (control.invalid) {
    <div>
      <mat-icon fontSet="mdi" fontIcon="mdi-help-circle" class="tooltip-icon" [matTooltip]="errorTooltip"></mat-icon>
    </div>
  }

  <div>
    <mat-icon fontSet="mdi" fontIcon="mdi-check" (click)="stopEditing()"></mat-icon>
  </div>
</div>


